import HcpMoa from "@/page-components-hcp/moa";

export default function HcpMoaPage() {
  
  return <HcpMoa />;
}

// Forward layout props to `_app` so it can wrap with the proper layout
HcpMoaPage.getLayoutProps = (pageProps, router) => (
  typeof HcpMoa.getLayoutProps === 'function'
    ? HcpMoa.getLayoutProps(pageProps, router)
    : {}
);